import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTASection = ({
  title = "Fifty-two years — a legacy that keeps soaring.",
  subtitle = "Talk to the team that has powered Indian skies since 1974.",
  primaryLabel = "Contact Us",
  primaryTo = "/contact",
  secondaryLabel = "Explore Products",
  secondaryTo = "/products",
}) => {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden bg-aero-navy">
      <div className="blueprint-grid absolute inset-0 opacity-30" />
      <div className="pointer-events-none absolute -right-10 -top-10 select-none">
        <span className="font-heading text-[16rem] font-black leading-none text-ink/[0.05]">
          1974
        </span>
      </div>
      <div className="relative mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-28">
        <Reveal>
          <div className="max-w-3xl">
            <h2 className="font-heading text-4xl font-black tracking-tight text-ink sm:text-5xl lg:text-6xl">
              {title}
            </h2>
            <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-steel sm:text-lg">
              {subtitle}
            </p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Link
                to={primaryTo}
                data-testid="cta-primary-btn"
                className="group flex items-center justify-center gap-2 rounded-full bg-saffron px-8 py-4 font-heading font-semibold text-white transition-all duration-300 hover:bg-saffron-soft"
              >
                {primaryLabel}
                <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
              <Link
                to={secondaryTo}
                data-testid="cta-secondary-btn"
                className="group flex items-center justify-center gap-2 rounded-full border border-steel/40 px-8 py-4 font-heading font-semibold text-ink transition-all duration-300 hover:border-saffron hover:text-saffron"
              >
                {secondaryLabel}
                <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
